import React from "react"
import { createIcon } from "@chakra-ui/react"

export default createIcon({
  displayName: "PauseIcon",
  viewBox: "0 0 18 20",
  path: (
    <path
      d="M2 18V2M16 18V2"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
})
